import { connect } from 'react-redux';
import type { SecondaryPriceType, SecondaryQuotationType } from 'state/secondaryMarket/productSearch';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { AppState } from 'state/state.model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = {
  isinCode?: string;
  denomination?: number;
  fileCode?: string;
  maturityDate?: string;
  quotationType?: Capitalize<SecondaryQuotationType>;
  priceType?: SecondaryPriceType;
  currency?: string;
  frozen: boolean;
};

export type ProductSummaryProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId)?.data;
  const frozen = getTabIsFrozen(state, tabId) ?? false;
  if (product === null) {
    return { frozen: true };
  }
  return {
    ...product,
    frozen,
    isinCode: product?.isin,
  };
};

export const connectProductSummary = connect(mapStateToProps);
